<template>
  <base-dialog :isOpen="dialogOpen" @closeDialog="toggleDialog" :ariaLabel="$t('notificationFilter.update_metadata')">
    <template slot="header">
      <div class="h-16 bg-secondary flex items-center justify-between text-white px-4">
        <div class="flex items-center">
          <h2 class="font-bold ml-2">{{$t('notificationFilter.update_metadata')}}</h2>
        </div>
        <span class="cursor-pointer" @click="toggleDialog">
          <base-button-icon name="cross" size="xs" iconSize="sm" mode="secondary" />
        </span>
      </div>
    </template>
    <template slot="main">
      <div class="form-wrapper p-4">
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="lg:mb-2 ">
            <label class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('notificationFilter.metadata_campo')}}
              <el-form-item prop="campo">
                <el-input
                  type="text"
                  class="w-full"
                  v-model="campo"
                  maxlength='50'
                  disabled
                />
              </el-form-item>
            </label>
            <AccessibleElSelect
              v-if="Tipo !== 0"
              v-model="form.valor"
              prop="valor"
              :options="valoresForAccessibleSelect"
              :withFormItem="true"
              :allow-create="Tipo === 1"
              maxlength="500"
              id-prefix="notificationupdatemetadatadialog"
            >
              <template slot="label"><base-obligatory-icon/>{{$t('notificationFilter.metadata_valor')}}</template>
            </AccessibleElSelect>
            <div v-else>
              <span id="notification-update-metadata-valor-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('notificationFilter.metadata_valor')}}</span>
              <el-form-item prop="valor">
                <el-input
                  type="textarea"
                  :rows="3"
                  class="w-full"
                  v-model="form.valor"
                  maxlength="500"
                  aria-labelledby="notification-update-metadata-valor-label"
                >
                  <template v-if="form.valor" slot="suffix">
                    <base-clear-input-button
                      aria-label="Limpiar campo"
                      @clear="form.valor = ''"
                    />
                  </template>
                </el-input>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="footer">
      <base-button class="w-full" @click="toggleDialog" mode="secondary-phantom-blue" :text="$t('app.cancel')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
      <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="uploadNewMetadato('ruleForm')" :disabled="isGeneralLoading" :loading="isGeneralLoading"/>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from './base/BaseDialog.vue'
import { editarMetadatoNEO } from '@/services/configurations/editarMetadatoNEO'
import { editarMetadatoRegla } from '@/services/configurations/editarMetadatoRegla'
import { getValoresMetadatoClienteAmpliado } from '@/services/clients/getValoresMetadatoClienteAmpliado'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default
{
  name: 'notification-update-metadata-dialog',
  components: {
    BaseDialog,
    AccessibleElSelect
  },
  props: {
    dialogOpen: {
      type: Boolean,
      default: false
    },
    metadataId: {
      type: Number,
      default: -1
    },
    campo: {
      type: String,
      default: ''
    },
    valorDefecto: {
      type: String,
      default: ''
    },
    idCliente: {
      type: Number,
      default: -1
    },
    idRegla: {
      type: Number,
      default: -1
    },
  },
  data: function () {
    return {
      isOpen: this.dialogOpen,
      form: {
        valor: '',
      },
      Tipo: 0,
      Valores: [],
      rules: {
        valor: [
          { validator: this.isGenericValidation, trigger: 'blur' },
        ],
      }
    }
  },
  watch: {
    dialogOpen: function (value, oldValue) {
      this.form.valor = this.valorDefecto
      if (value) this.getDataMetadato()
    },
  },
  mounted: async function () {
  },
  computed: {
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    valoresForAccessibleSelect: function () {
      return this.Valores.map((item, index) => ({
        id: index,
        name: item,
        value: item
      }))
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    }
  },
  methods: {
    toggleDialog: function () {
      this.isOpen = !this.isOpen
      this.form.valor = ''
      this.$emit('toggleDialog')
    },
    getDataMetadato: async function () {
      try {
        this.EsLista = false
        this.Valores = []
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Campo: this.campo, 
          idCliente: this.idCliente, 
        }
        const response = await getValoresMetadatoClienteAmpliado(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.Tipo = response.Tipo
          this.Valores = response.Valores
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    uploadNewMetadato: async function (ruleForm) {
      try {
        this.$store.commit('setAjaxRequestPending', true)
        this.$refs[ruleForm].validate(async valid => {
          this.$store.commit('setIsLoading', true)
          if (valid) {
            const payload = { 
              idMetadato: this.metadataId, 
              Valor: this.form.valor, 
              Campo: this.campo,
              idRegla: this.idRegla,
            }
            let response
            if (this.idRegla === -1) {
              response = await editarMetadatoNEO(payload)
            } else {
              response = await editarMetadatoRegla(payload)
            }
            if (response.blnError === true) {
              this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
            } else {
              this.$emit('applyDialog')
              this.doFeedback('Metadato actualizado correctamente', 'success')
            }
            this.$store.commit('setIsLoading', false)
          } else {
            this.doFeedback('Error al procesar los datos, revise la información')
          }
        })
      } catch (error) {
        this.$store.commit('setIsLoading', false)
        this.doFeedback()
      } 
    },
  }
}
</script>

<style lang="scss" scoped>
.center {
  margin: auto;
  width: 60%;
  border: none;
  padding: 1px;
}

</style>
